import { LinearProgress } from '@mui/joy';
import Box from '@mui/joy/Box';

import { useLocation } from 'react-router-dom';

import { PendingInvite } from '@/components/NavSidebar/InviteNotification';
import { useGroupedOrgInvites } from '@/components/NavSidebar/useGroupedInvites';

import { PageTitle } from '../../components/PageTitle';

export const NoMatch = () => {
  const location = useLocation();
  const isRootPath = location.pathname === '/';
  const pendingInvites = useGroupedOrgInvites({ skip: !isRootPath });
  if (pendingInvites.isLoading) return <LinearProgress />;
  return (
    <Box paddingY={4}>
      {pendingInvites.data?.length && isRootPath ? (
        <>
          <div className="mb-2">Invitations</div>
          <div className="flex max-w-[600px] flex-wrap gap-4">
            {pendingInvites.data?.map((t) => (
              <PendingInvite key={t.id} {...t} type="organization" />
            ))}
          </div>
        </>
      ) : (
        <PageTitle>404 💬🦜🔗</PageTitle>
      )}
    </Box>
  );
};
